var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 52,
    viewBox: "0 0 160 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_10_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3999 51.0519V49.1609C63.0288 49.2205 63.662 49.2205 64.2909 49.1609C66.4369 49.1609 68.0729 47.296 68.0729 44.434V12.291H70.9089V44.4359C70.9089 49.2069 68.2279 51.9999 64.2909 51.9999C63.4569 51.9999 63.2949 51.2329 62.3999 51.0519ZM68.0729 -0.00305176H71.8549V3.77896H68.0729V-0.00305176Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4719 30.252V12.2889H81.3079V30.253C81.3079 36.516 84.6209 40.653 90.7629 40.653C96.7269 40.653 101.163 35.629 101.163 29.308V12.2889H103.999V42.541H101.163V36.868C99.1359 40.447 96.3089 43.486 90.7629 43.486C83.0699 43.489 78.4719 37.528 78.4719 30.252Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.345 34.9816V15.1266H110.618V12.2906H115.345V1.89062H118.181V12.2906H129.526V15.1266H118.181V34.0356C118.133 34.9175 118.271 35.7996 118.586 36.6246C118.901 37.4495 119.387 38.1987 120.012 38.8232C120.636 39.4477 121.385 39.9335 122.21 40.2489C123.035 40.5643 123.917 40.7022 124.799 40.6536C126.29 40.6536 126.851 39.5376 128.581 38.7626V41.5986C127.104 42.288 125.483 42.6121 123.854 42.5436C119.143 42.5426 115.345 40.7666 115.345 34.9816Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.309 34.035V33.09C133.309 26.769 138.674 23.635 146.545 23.635C150.038 23.5015 153.533 23.8191 156.945 24.58V23.635C156.945 17.492 152.807 14.1799 146.545 14.1799C142.845 14.1799 139.893 15.5799 137.09 17.0159L136.145 14.1799C139.674 12.4174 143.547 11.4494 147.49 11.3439C149.239 11.3056 150.979 11.6208 152.603 12.2706C154.228 12.9205 155.705 13.8917 156.945 15.126C158.973 17.153 159.781 19.878 159.781 23.635V42.544H156.945V36.871C154.857 39.793 151.384 43.489 145.6 43.489C139.934 43.489 133.309 40.356 133.309 34.035ZM156.945 31.199V27.416C153.528 26.6897 150.037 26.3725 146.545 26.471C140.105 26.471 137.09 28.8539 137.09 33.0889C137.09 37.5019 140.947 40.653 145.599 40.653C151.802 40.653 156.946 36.745 156.946 31.196L156.945 31.199Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.437 51.9999H6.61905C2.65905 51.9999 0.00103564 48.3999 0.00103564 44.4359V6.61795C-0.0502623 5.73545 0.0857963 4.85208 0.400236 4.02591C0.714676 3.19973 1.20039 2.44945 1.82547 1.82437C2.45054 1.19929 3.20083 0.713577 4.02701 0.399137C4.85318 0.0846977 5.73655 -0.051361 6.61905 -6.29947e-05H44.437C45.3192 -0.0507883 46.2021 0.0857084 47.0277 0.400419C47.8534 0.71513 48.6031 1.20096 49.2276 1.82599C49.8522 2.45102 50.3375 3.20109 50.6515 4.02698C50.9656 4.85286 51.1014 5.73585 51.05 6.61795V44.4359C51.05 48.3959 48.397 51.9999 44.437 51.9999Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0181 35.924V15.1239L34.9821 5.66895V46.3239L17.0181 35.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.491 37.817V5.672L53.891 11.345V32.145L43.491 37.817Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip1_10_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.33 71.1915C162.853 71.1915 167.33 66.7141 167.33 61.191C167.33 55.6679 162.853 51.1906 157.33 51.1906C151.806 51.1906 147.329 55.6679 147.329 61.191C147.329 66.7141 151.806 71.1915 157.33 71.1915Z",
    fill: "#787878"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159.782,
    height: 52,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 50,
    fill: "white",
    transform: "translate(126.782 50)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuta);
export default __webpack_public_path__ + "static/media/juta.75b5d2c68a6e4e6412f0ead5d8967039.svg";
export { ForwardRef as ReactComponent };